import { render, staticRenderFns } from "./ChatRecent.vue?vue&type=template&id=20929d55"
import script from "./ChatRecent.vue?vue&type=script&lang=js"
export * from "./ChatRecent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports